import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

export default function About() {
  return (
    <div className="bg-[#dce2d7] text-[#1f241d]">
      <Helmet>
        <title>Om os - PR Entreprise & Anlæg ApS</title>
        <meta
          name="description"
          content="Læs mere om PR Entreprise & Anlæg ApS i Ishøj (CVR: 43852507). Autoriseret kloakmester, brolægning og anlægsarbejde for private og erhverv."
        />
        <meta property="og:title" content="Om os - PR Entreprise & Anlæg ApS" />
      </Helmet>

      {/* Page Header */}
      <section className="relative bg-[#141f14] text-white py-16 lg:py-20 border-b border-[#233323] overflow-hidden">
        <img
          src="https://assets.auxodev.dk/cdn-cgi/image/width=1600,quality=85,format=auto/assets/4a3bbf24-8a93-4bbf-a600-7956f25025f9/havearbejde-1.jpg"
          alt=""
          className="absolute inset-0 w-full h-full object-cover opacity-25 pointer-events-none"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#141f14] via-[#141f14]/90 to-transparent pointer-events-none" />
        <div className="relative max-w-[109rem] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl space-y-4 animate-fade-in-up">
            <span className="text-[#9ecc49] text-xs font-bold uppercase tracking-widest bg-[#3d5229] px-3 py-1 rounded-none border border-[#9ecc49]/30">
              Om os
            </span>
            <h1 className="font-heading text-2xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-white">
              Om PR Entreprise & Anlæg
            </h1>
            <p className="text-[#e8eee6] text-base sm:text-lg leading-relaxed">
              Vi er et firma med over 20 års erfaring. Derudover har vi også autorisation inden for kloak og vores kloakmestre står klar til at hjælpe dig.
            </p>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16 bg-[#dce2d7] text-[#1f241d]">
        <div className="max-w-[109rem] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
            
            <div className="lg:col-span-8 space-y-8">
              <div className="bg-white p-8 rounded-none border border-[#cbd3c5] shadow-sm space-y-6">
                <h2 className="font-heading text-xl sm:text-2xl lg:text-3xl font-bold text-[#1f241d]">
                  Om PR Entreprise & Anlæg
                </h2>
                <p className="text-[#4e564a] leading-relaxed text-base font-medium">
                  Vi er et firma med over 20 års erfaring. Derudover har vi også autorisation inden for kloak og vores kloakmestre står klar til at hjælpe dig.
                </p>
                <p className="text-[#4e564a] leading-relaxed text-base">
                  Vi tilbyder også at lave arbejde som underentreprenør.
                </p>
                <p className="text-[#4e564a] leading-relaxed text-base font-semibold text-[#3d5229] flex items-center gap-2">
                  <i className="fa-solid fa-clock text-[#9ecc49] bg-[#141f14] p-2" aria-hidden="true" />
                  <span>Vi arbejder også gerne aften og weekend.</span>
                </p>

                {/* Key Highlight Badges */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-4 border-t border-[#dce2d7]">
                  <div className="bg-[#f4f7f2] p-4 border border-[#cbd3c5] flex items-center gap-3">
                    <div className="w-10 h-10 bg-[#3d5229] text-[#9ecc49] flex items-center justify-center font-bold text-lg">
                      20+
                    </div>
                    <div>
                      <div className="font-bold text-sm text-[#1f241d]">Års erfaring</div>
                      <div className="text-xs text-[#626c5d]">Solid brancheerfaring</div>
                    </div>
                  </div>

                  <div className="bg-[#f4f7f2] p-4 border border-[#cbd3c5] flex items-center gap-3">
                    <div className="w-10 h-10 bg-[#3d5229] text-[#9ecc49] flex items-center justify-center text-lg">
                      <i className="fa-solid fa-certificate" aria-hidden="true" />
                    </div>
                    <div>
                      <div className="font-bold text-sm text-[#1f241d]">Autoriseret Kloakmester</div>
                      <div className="text-xs text-[#626c5d]">Udføres efter alle lovkrav</div>
                    </div>
                  </div>

                  <div className="bg-[#f4f7f2] p-4 border border-[#cbd3c5] flex items-center gap-3">
                    <div className="w-10 h-10 bg-[#3d5229] text-[#9ecc49] flex items-center justify-center text-lg">
                      <i className="fa-solid fa-handshake" aria-hidden="true" />
                    </div>
                    <div>
                      <div className="font-bold text-sm text-[#1f241d]">Underentreprenør</div>
                      <div className="text-xs text-[#626c5d]">Arbejde for hovedentreprenører</div>
                    </div>
                  </div>

                  <div className="bg-[#f4f7f2] p-4 border border-[#cbd3c5] flex items-center gap-3">
                    <div className="w-10 h-10 bg-[#3d5229] text-[#9ecc49] flex items-center justify-center text-lg">
                      <i className="fa-solid fa-calendar-check" aria-hidden="true" />
                    </div>
                    <div>
                      <div className="font-bold text-sm text-[#1f241d]">Aften & Weekend</div>
                      <div className="text-xs text-[#626c5d]">Fleksible arbejdstider</div>
                    </div>
                  </div>
                </div>
              </div>

              {/* What we work with */}
              <div className="bg-white p-8 rounded-none border border-[#cbd3c5] shadow-sm space-y-6">
                <h2 className="font-heading text-xl sm:text-2xl font-bold text-[#1f241d] flex items-center gap-3">
                  <span className="w-2 h-7 bg-[#3d5229]" />
                  Vi arbejder blandt andet med:
                </h2>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {[
                    { title: 'Udlægning af beton', icon: 'fa-cubes' },
                    { title: 'Opbygning af fundamenter & terrændæk', icon: 'fa-trowel-bricks' },
                    { title: 'Udgravning af terræn & render', icon: 'fa-truck-field' },
                    { title: 'Belægningsopgaver', icon: 'fa-grip' },
                    { title: 'Udlægning af rullegræs', icon: 'fa-seedling' },
                    { title: 'Havearbejde', icon: 'fa-tree' },
                    { title: 'Kloakarbejde', icon: 'fa-pipe-valve' }
                  ].map((service, idx) => (
                    <div key={idx} className="flex items-center gap-3 bg-[#f4f7f2] p-4 border border-[#cbd3c5]">
                      <i className="fa-solid fa-circle-check text-[#3d5229] text-lg" aria-hidden="true" />
                      <span className="font-bold text-[#1f241d] text-sm sm:text-base">{service.title}</span>
                    </div>
                  ))}
                </div>
              </div>

              <div className="bg-[#cbd3c5] p-8 rounded-none border border-[#3d5229]/20 space-y-4">
                <h2 className="font-heading text-xl sm:text-2xl font-bold text-[#1f241d]">
                  Målgrupper & Geografisk Dækning
                </h2>
                <p className="text-[#1f241d] text-base leading-relaxed">
                  PR Entreprise & Anlæg ApS udfører opgaver i Ishøj, Greve, Vallensbæk, Høje-Taastrup, Storkøbenhavn og på det øvrige Sjælland.
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 text-sm font-semibold text-[#1f241d] pt-2">
                  <div className="bg-white p-4 rounded-none border border-[#cbd3c5] flex items-center gap-2">
                    <i className="fa-solid fa-house-user text-[#3d5229]" aria-hidden="true" />
                    <span>Private Grundejere</span>
                  </div>
                  <div className="bg-white p-4 rounded-none border border-[#cbd3c5] flex items-center gap-2">
                    <i className="fa-solid fa-building text-[#3d5229]" aria-hidden="true" />
                    <span>Erhvervsvirksomheder</span>
                  </div>
                  <div className="bg-white p-4 rounded-none border border-[#cbd3c5] flex items-center gap-2">
                    <i className="fa-solid fa-users-gear text-[#3d5229]" aria-hidden="true" />
                    <span>Boligselskaber & Bygherrer</span>
                  </div>
                </div>
              </div>

            </div>

            {/* Sidebar with Facts & Contact info */}
            <div className="lg:col-span-4 space-y-6">
              <div className="bg-[#141f14] text-white p-6 rounded-none border border-[#233323] shadow-lg space-y-4">
                <h3 className="font-heading font-bold text-xl text-white border-b border-[#233323] pb-3">
                  Virksomhedsoplysninger
                </h3>
                
                <ul className="space-y-3 text-sm text-[#e8eee6]">
                  <li className="flex justify-between items-center py-1 border-b border-[#233323]">
                    <span className="text-gray-400">CVR-nr:</span>
                    <span className="font-mono font-bold text-[#9ecc49]">43852507</span>
                  </li>
                  <li className="flex justify-between items-center py-1 border-b border-[#233323]">
                    <span className="text-gray-400">Selskab:</span>
                    <span className="font-semibold text-white">ApS</span>
                  </li>
                  <li className="flex justify-between items-center py-1 border-b border-[#233323]">
                    <span className="text-gray-400">Autorisation:</span>
                    <span className="font-semibold text-[#9ecc49]">Kloakmester</span>
                  </li>
                  <li className="flex justify-between items-center py-1 border-b border-[#233323]">
                    <span className="text-gray-400">Adresse:</span>
                    <span className="font-semibold text-white">Ishøj Bygade 90, 2635 Ishøj</span>
                  </li>
                  <li className="flex justify-between items-center py-1 border-b border-[#233323]">
                    <span className="text-gray-400">Telefon:</span>
                    <a href="tel:22231010" className="font-bold text-[#9ecc49] hover:underline">Tlf. 22 23 10 10</a>
                  </li>
                  <li className="flex justify-between items-center py-1">
                    <span className="text-gray-400">E-mail:</span>
                    <a href="mailto:info@prentreprise.dk" className="font-medium text-white hover:text-[#9ecc49] underline">info@prentreprise.dk</a>
                  </li>
                </ul>

                <div className="pt-3">
                  <Link
                    to="/kontakt"
                    className="w-full bg-[#3d5229] hover:bg-[#2e3f1e] text-white font-bold py-3 px-4 rounded-none text-center block uppercase tracking-wide text-xs transition-colors border border-[#9ecc49]/40"
                  >
                    Indhent uforpligtende tilbud
                  </Link>
                </div>
              </div>

              {/* Call out card */}
              <div className="bg-[#3d5229] text-white p-6 rounded-none space-y-3">
                <i className="fa-solid fa-headset text-3xl text-[#9ecc49]" aria-hidden="true" />
                <h3 className="font-heading font-bold text-lg text-[#9ecc49]">Har du et projekt i tankerne?</h3>
                <p className="text-[#e8eee6] text-xs leading-relaxed">
                  Vi kommer gerne ud og besigtiger din grund eller dit anlæg og udarbejder et uforpligtende skriftligt tilbud.
                </p>
                <a
                  href="tel:22231010"
                  className="inline-block bg-[#9ecc49] text-[#1f241d] font-bold text-xs uppercase px-4 py-2.5 rounded-none transition-colors"
                >
                  Ring Tlf. 22 23 10 10
                </a>
              </div>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
}
